import "../stylesheets/App.css";
import "../stylesheets/ChangePassword.css";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import PopupMailEnviado from "./subcomponents/PopupMailEnviado.js";
import Loader from "./subcomponents/Loader.js";

function ChangePassword() {
  const [password, setPassword] = useState("");
  const [passwordNew, setPasswordNew] = useState("");
  const [passwordRepeat, setPasswordRepeat] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [openPopup, setOpenPopup] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const changePassword = async () => {
    setErrorMsg("");

    // 1) Validación antes de prender loader / llamar API
    if (passwordNew !== passwordRepeat) {
      setErrorMsg("Las contraseñas no coinciden");
      return;
    }

    const userInfoRaw = localStorage.getItem("user-info");
    if (!userInfoRaw) {
      setErrorMsg("Tu sesión expiró. Volvé a iniciar sesión.");
      return;
    }

    const email = JSON.parse(userInfoRaw)?.email;
    if (!email) {
      setErrorMsg("No se encontró el email del usuario. Volvé a iniciar sesión.");
      return;
    }

    const item = { email, password, passwordNew };

    try {
      setLoading(true);

      let result = await fetch(
        process.env.REACT_APP_API_BASE_URL + "/users/changePassword",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(item),
        }
      );

      result = await result.json();

      if (result.status === 200) {
        setOpenPopup(true);
      } else {
        setErrorMsg(result?.data?.errors?.[0]?.msg || "Error al cambiar la contraseña");
      }
    } catch (e) {
      setErrorMsg("Error de conexión. Intentá nuevamente.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <img
        className="change-password-img"
        src={process.env.PUBLIC_URL + "/images/Logo-Registro-HMQ.png"}
        alt=""
      />

      <div className="change-password-container section-70">
        <h1 className="change-password-title">Cambiar contraseña</h1>

        <input
          type="password"
          className="inp"
          placeholder="Contraseña actual"
          id="password"
          name="password"
          value={password}
          onChange={(e) => {
            setPassword(e.target.value);
            if (errorMsg) setErrorMsg("");
          }}
        />

        <input
          type="password"
          className="inp"
          placeholder="Nueva contraseña"
          id="passwordNew"
          name="passwordNew"
          value={passwordNew}
          onChange={(e) => {
            setPasswordNew(e.target.value);
            if (errorMsg) setErrorMsg("");
          }}
        />

        <input
          type="password"
          className="inp"
          placeholder="Repetir nueva contraseña"
          id="passwordRepeat"
          name="passwordRepeat"
          value={passwordRepeat}
          onChange={(e) => {
            setPasswordRepeat(e.target.value);
            if (errorMsg) setErrorMsg("");
          }}
        />

        <span className="error-msg">{errorMsg}</span>

        <button
          type="submit"
          className="btn red-btn mb-2"
          onClick={changePassword}
          disabled={loading}
        >
          Cambiar contraseña
        </button>

        <button className="btn blue-btn" onClick={() => navigate("/profile")} disabled={loading}>
          Cancelar
        </button>
      </div>

      {loading ? <Loader /> : ""}

      {openPopup ? (
        <PopupMailEnviado
          title="Contraseña guardada con éxito"
          description="¡Ya puedes volver a jugar!"
          setOpenPopup={setOpenPopup}
        />
      ) : (
        ""
      )}
    </>
  );
}

export default ChangePassword;
